/** Case and accent insensitive matching for labels and technical keys. */
function fold(value) {
  return String(value ?? "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ı/g, "i");
}

export function matchesTabSearch(value, query) {
  return fold(value).includes(fold(String(query || "").trim()));
}
